const { toWords } = require('number-to-words')
const wordsToNumbers = require('words-to-number')
const {getDecimalDigits} = require('utils/exportUtils')



export default async function (num = 100) {
    console.log('numbers are', num)
    let decimal = getDecimalDigits(num)
    let numToWords = toWords(num)
    let decimalToWords = toWords(decimal)
    console.log('to words are', numToWords)

    /*
    let splittedNumToWords = numToWords.split(",")


    let lastHundreds = splittedNumToWords[splittedNumToWords.length - 1]
    let lastHundredsToArray = lastHundreds.trim().split(" ")
    let lastTens = lastHundredsToArray[lastHundredsToArray.length - 1]
    let lastTensToWords = await wordsToNumbers(lastTens)

    let text = splittedNumToWords.slice(0, splittedNumToWords.length - 1)

    let result = `${text.join()} ${lastHundredsToArray.slice(0, lastHundredsToArray.length - 1).join(" ")} pesos and ${lastTensToWords.response}/100 only`

    console.log(result.toUpperCase())*/

    let result = `${numToWords} PESOS AND ${decimalToWords} CENTAVOS ONLY`
    return result.toUpperCase()
}

